<template>
  <div class="h-100">
    <main role="main" class="h-100">
      <common-master-table
        primary-key="chuteSerialId"
        table-no="mstChute"
        table-api="master/chute"
        ref="commonMasterTable"
        :editable="editableMixin.chute"
        :addable="editableMixin.chute"
        :gridxSize="gridxSize"
        :gridySize="gridySize"
        :mapping-no="`ie-chute`"
        socket-entity="CHUTE_SOCKET"
        :overlapMode="true"
        :emitEventOnManualDataFetching="true"
        v-on:manual-data-fetching="manualFetchData"
      >
        <template v-slot:overlap_header>
          <th class="grid-overlap">グリッド重複</th>
        </template>
        <template v-slot:overlap_body="{ item }">
          <td class="text-danger text-center">{{ item.overlap }}</td>
        </template>
        <template v-slot:overlap_button_preview_modal>
          <b-button variant="outline-info" class="chute-preview-button" @click="showPreviewModal">
            プレビュー（X{{ gridxSize }}：Y{{ gridySize }}）
          </b-button>
        </template>
      </common-master-table>
      <!-- 編集モーダル -->
      <b-modal id="preview-modal-center" size="xl" centered title="プレビュー" hide-footer scrollable @hidden="isModalOpening = false"  >
        <b-container>
          <div class="col-5 left chute-info">
            <div class="label-chute">
              <span>レイヤ</span>
            </div>
            <div class="chute-layer">
              <form-select-component
                v-model="chuteSelected"
                :options="chuteSelectOptions.map(chute => chute.value)"
                :customLabel="displayChuteLayerLabels"
                placeholder="レイヤー"
                :isNoBorder="true"
                :openDirection="'bottom'"
                :left="true"
              />
            </div>
          </div>
          <!-- テーブル表示 -->
          <div class="table_wrapper" ref="tableWrapper">
            <table class="chute_grid_table" ref="table" :style="{ width: calcTableWidth }">
              <thead>
                <tr>
                  <th v-for="col in chutePreviewLabels" :key="`tbth-${col}`"
                    class="table-active text-center"
                  >
                    {{ col }}
                  </th>
                </tr>
              </thead>
              <tbody v-if="previewData !== null">
                <tr v-for="(row, idx) in previewData" :key="`tbtr-${chuteSelected}-${idx}`">
                  <td class="guide_cell">{{ idx + 1 }}</td>
                  <td v-for="(item, idx2) in row" :key="`tbtd-${chuteSelected}-${idx}-${idx2}`"
                      class="text-center"
                  >
                    <p class="chute_no">{{ item.chute_no }}</p>
                    <P class="chute_name">{{ item.chute_name }}</P>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-container>
      </b-modal>
    </main>
  </div>
</template>

<script>
import CommonMasterTable from '../custom-components/CommonMasterTable'
import SearchModalComponent from '../custom-components/SearchModalComponent'
import { mapGetters, mapState } from 'vuex'
import RouterUtils from '../../_helpers/router.util'
import FormSelectComponent from '../custom-components/FormSelectComponent.vue'
import AppConstants from '../../constants/app.constants'
import CommonUtils from '../../mixins/commonUtils.js'
export default {
  components: {
    // コンポーネント分割化
    CommonMasterTable,
    SearchModalComponent,
    FormSelectComponent
  },
  mixins: [CommonUtils],
  data() {
    return {
      tableNo: 'mstChute',
      overlap: 'mstChutesGridOverlap',
      removeKeys: [],
      chutePreviewLabels: [],
      chutePreviewDatas: [],
      chuteLayers: [],
      gridxSize: 0,
      gridySize: 0,
      chuteSelected: null,
      chuteSelectOptions: [],
      updateQueryStr: '',
      isModalOpening: false
    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.hasOwnProperty('limit') && Object.keys(to.query).length === 1) {
      RouterUtils.correctTableRowsLimitParam(to.query)
      this.$refs.commonMasterTable.initData()
      this.$_fetch_setting()
    }
  },
  created() {
    this.$_fetch_setting()
  },
  computed: {
    ...mapState('socket', ['messages']),
    calcTableWidth: function () {
      if (this.gridxSize !== 0) {
        return (160 * this.gridxSize + 30) + 'px'
      } else {
        return 'auto'
      }
    },
    previewData: function() {
      if (this.chuteSelected !== null && this.chuteSelected > -1) {
        return this.chutePreviewDatas[this.chuteSelected]
      } else {
        return null
      }
    }
  },
  watch: {
    messages(newValue, oldValue) {
      if (Array.isArray(newValue) && newValue.includes(AppConstants.CHUTE_SOCKET)) {
        this.$_fetch_setting()
      }
    }
  },
  methods: {
    ...mapGetters('setting', ['getSetting']),
    async $_fetch_setting() {
      this.gridxSize = 0
      this.gridySize = 0
      this.$axios
        .get(`/master/chute`)
        .then(response => {
          const resluts = response.data.mstChute
          resluts.filter(item => item.gridx && item.gridy).map(item => {
            if (this.gridxSize < item.gridx) {
              this.gridxSize = item.gridx
            }
            if (this.gridySize < item.gridy) {
              this.gridySize = item.gridy
            }
          })
          this.$_generateChutePreviewGridLabels()
          this.$_generateChutePreviewGridData(resluts)
        })
        .catch(err => {
          console.log(err)
        })
    },
    manualFetchData() {
      this.$_fetch_setting()
    },
    showPreviewModal() {
      this.$axios.get(`/master/chute`)
        .then(response => {
          const resluts = response.data.mstChute
          this.$_generateChutePreviewGridData(resluts)
          this.isModalOpening = true
        })
        .catch(err => {
          console.log(err)
        })
      this.$bvModal.show('preview-modal-center')
    },
    /* プレビュー用グリッドヘッダを作成 */
    async $_generateChutePreviewGridLabels() {
      this.chutePreviewLabels = []
      this.chutePreviewLabels[0] = ''
      for (let j = 1; j <= this.gridxSize; j++) {
        this.chutePreviewLabels[j] = j
      }
    },
    /* プレビュー用グリッドデータをセット */
    $_generateChutePreviewGridData(chuteMst) {
      // レイヤーを作成
      this.chuteLayers = []
      for (let i = 0, len = chuteMst.length; i < len; i++) {
        if (chuteMst[i].layer === null) { continue }
        if (this.chuteLayers.indexOf(chuteMst[i].layer) === -1) {
          this.chuteLayers.push(chuteMst[i].layer)
        }
      }
      this.chuteLayers.sort()
      this.chuteSelectOptions = []
      if (this.chuteLayers.length > 0) {
        for (let i = 0, len = this.chuteLayers.length; i < len; i++) {
          this.chuteSelectOptions.push({
            value: i,
            text: this.chuteLayers[i]
          })
        }
      }
      // グリッド枠を再作成
      this.chutePreviewDatas = []
      for (let i = 0, len = this.chuteLayers.length; i < len; i++) {
        this.chutePreviewDatas[i] = []
        for (let j = 0; j < this.gridySize; j++) {
          this.chutePreviewDatas[i][j] = []
          for (let k = 0; k < this.gridxSize; k++) {
            this.chutePreviewDatas[i][j][k] = { chute_no: '', chute_name: '' }
          }
        }
      }
      for (let i = 0, len = chuteMst.length; i < len; i++) {
        const item = chuteMst[i]
        if (item.gridx === null || item.gridy === null || item.layer === null) { continue }
        if (item.gridx > this.gridxSize || item.gridy > this.gridySize) { continue }
        const layer = this.chuteLayers.indexOf(item.layer)
        if (layer === -1) { continue }
        let cellItem = { chute_no: '', chute_name: '' }
        cellItem.chute_no = item.chuteNo
        cellItem.chute_name = (item.chuteName !== null && item.chuteName.length > 10) ? item.chuteName.substring(0, 10) : item.chuteName
        this.chutePreviewDatas[layer][item.gridy - 1][item.gridx - 1] = cellItem
      }
      // While the modal is not opening OR the selected chute is empty data
      // Set the selected chute variable default value
      if (!this.isModalOpening || !this.chutePreviewDatas[this.chuteSelected]) {
        this.chuteSelected = 0
      }
    },
    /**
     * シュート層のラベルを表示
     * @param {number} chuteLayer ユーザーが選択した値
     */
    displayChuteLayerLabels(chuteLayer) {
      const chuteLayerLabel = this.displayChuteLabels(chuteLayer, this.chuteSelectOptions)
      return chuteLayerLabel
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-body {
  overflow-x: auto;
  .table_wrapper {
    margin: 10px 0 0;
    float: left;
    .chute_grid_table {
      margin-right: 30px;
      th {
        background-color: transparent;
      }
      td {
        padding: 4px;
        width: 160px;
        border: 1px solid #e6e6e6;
        white-space: nowrap;
        .chute_no,
        .chute_name {
          margin-bottom: 0;
        }
      }
      td.guide_cell {
        width: 30px;
        text-align: right;
        border-top: none;
        border-bottom: none;
        border-left: none;
      }
    }
  }
  .table_wrapper:after {
    content: "";
    clear: both;
    display: block;
  }
  .chute-info {
    display: flex;
    align-items: center;
    white-space: nowrap;
    .label-chute {
      margin-right: 33px;
      margin-bottom: 0;
    }
    .chute-layer {
      display: flex;
      align-items: center;
    }
  }
}

.chute-preview-button {
  @include responsive-fs(12);
}
.grid-overlap {
  padding-top: 0;
  padding-bottom: 0;
  vertical-align: middle;
  text-align: center;
  border-top: none;
}
</style>



// WEBPACK FOOTER //
// src/components/mst-tables/ChuteMaster.vue